import { Entity, Field } from "typegraph";

@Entity({one: "programProgress", many: "programsProgress"})
export default class ProgramProgress {

	// a list of tracks with some progress?

	@Field()
	public id: string;

	@Field()
	public name: string;

	@Field()
	public total: number;

	@Field()
	public completed: number;

}



// WEBPACK FOOTER //
// ./src/panels/programStatus/entities/ProgramProgress.ts